export default "<p>\r\n  view-documents works!\r\n</p>\r\n";